module.exports = __webpack_public_path__ + "fonts/Montserrat-ExtraLight.324a0e0c.ttf";